/** Display macro keys returned by Diet API (plans/templates). */

export const TAG_TO_DISPLAY = {
  ENERC_KCAL: "calories",
  PROCNT: "proteins",
  CHOCDF: "carbs",
  FAT: "fats",
  FIBTG: "fiber",
  SUGAR: "sugars",
};

/** Base (unscaled) value from recipe_details.nutrients compact object or legacy array. */
export function getBaseNutrient(detail, tagOrDisplayKey) {
  const nutrients = detail?.nutrients;
  if (!nutrients) return 0;
  const displayKey = TAG_TO_DISPLAY[tagOrDisplayKey] || tagOrDisplayKey;
  if (typeof nutrients === "object" && !Array.isArray(nutrients)) {
    return Number(nutrients[displayKey] ?? 0);
  }
  if (Array.isArray(nutrients)) {
    const tag =
      Object.entries(TAG_TO_DISPLAY).find(([, v]) => v === displayKey)?.[0] ||
      tagOrDisplayKey;
    const row = nutrients.find((n) => n.nutrient_tag_name === tag);
    return Number(row?.measure ?? 0);
  }
  return 0;
}

/** Normalize nutrients to compact display object for food_details. */
export function nutrientsToDisplayObject(nutrients) {
  if (!nutrients) return {};
  if (typeof nutrients === "object" && !Array.isArray(nutrients)) {
    return {
      calories: Number(nutrients.calories ?? 0),
      proteins: Number(nutrients.proteins ?? 0),
      carbs: Number(nutrients.carbs ?? 0),
      fats: Number(nutrients.fats ?? 0),
      fiber: Number(nutrients.fiber ?? 0),
      sugars: Number(nutrients.sugars ?? 0),
    };
  }
  return {
    calories: getBaseNutrient({ nutrients }, "ENERC_KCAL"),
    proteins: getBaseNutrient({ nutrients }, "PROCNT"),
    carbs: getBaseNutrient({ nutrients }, "CHOCDF"),
    fats: getBaseNutrient({ nutrients }, "FAT"),
    fiber: getBaseNutrient({ nutrients }, "FIBTG"),
    sugars: getBaseNutrient({ nutrients }, "SUGAR"),
  };
}
